export const getProgramUrl = ({
  programID,
  version = 'v3',
}: {
  programID: number | string;
  version?: string;
}) => `/api/${version}/requirementsTracker/program/${programID}`;

export const getProgramsBySchoolUrl = ({
  schoolID,
  version = 'v3',
}: {
  schoolID: string;
  version?: string;
}) => `/api/${version}/requirementsTracker/program/school/${schoolID}`;

export const getProgramCoursesByProgramIdUrl = ({
  programID,
  version = 'v3',
}: {
  programID: number;
  version?: string;
}) => `/api/${version}/requirementsTracker/program/${programID}/courses`;
